import { Branding, ModalContainer } from "@bcm-dev/bcms-vite";
import { LeftColumnContainer, RightColumnContainer } from 'components/shared/containers/LayoutContainer';
import PageContainer from 'components/shared/containers/PageContainer';
import CardDetailsNavWidget from 'components/shared/widgets/CardDetailsNavWidget';
import CardWidget from 'components/shared/widgets/CardWidget';
import ManageCardNavWidget from 'components/shared/widgets/ManageCardNavWidget';
import SettingsNavWidget from 'components/shared/widgets/SettingsNavWidget';
import modals from "components/ui/CustomModal/components";
import UICardSelect from "components/ui/UICardSelect";
import React, { useEffect, useState } from 'react';
import PageHeader from '../PageHeader';
import "./styles.css";
/**
 * @function PageContent
 * @param {React.Component} children - React components that's being wrapped by the right column.
 * @return {React.Component}
 * @exported true
 * @description The PageContent component lays out the whole page into the two columns; 
 * the left column and the right column. The children are passed through to the right column. 
 * It also lays out the header at the top of the page.
 * @example
 * <PageContent><someComponentForTheRightColumn /></PageContent>
 */
export default function PageContent(props) {
  const [ render, setRender ] = useState(false);

  useEffect(() => {
    // Function to re-render the page since "useBCMSContext"
    // is limited as to what gets rendered.
    const renderPageContent = evt => {
      if(evt.data.message) {
        if(evt.data.message.renderPageContent) {
          setRender(!render);
        }
      }
    };

    // Rerenders the page when called. 
    // Currently used to update the "Card on file" notifcation number
    // when "BCMSRecord.batch" is called.
    window.addEventListener("message", renderPageContent);

    // Remove code after this component is unmounted.
    return () => {
      window.removeEventListener("message", renderPageContent);
    }
  });

  return (
    
    <PageContainer>
    <ModalContainer modals={modals}>
      <div className="page-content main-layout-grid-container">
        <Branding id="nonfiserv_olb_chw23" value="false" default="falses">
          <Branding id="standalone_chw23" value="true">
            <PageHeader />
          </Branding>
        </Branding>

        <Branding id="nonfiserv_olb_chw23" value="true" default="false">
          <PageHeader />
        </Branding>
        {/* <UICardSelect /> */}
        <div className="flex-container card-select">
          <UICardSelect />
        </div>
        <LeftColumnContainer>
          <CardWidget />
          <CardDetailsNavWidget />
          <ManageCardNavWidget />

          <Branding id="nonfiserv_olb_chw23" value="true" default="false">
            <SettingsNavWidget />
          </Branding>

          <Branding id="nonfiserv_olb_chw23" value="false" default="false">
            <Branding id="standalone_chw23" value="false">
              <SettingsNavWidget />
            </Branding>
          </Branding>

        </LeftColumnContainer>
        <RightColumnContainer>
          {props.children}
        </RightColumnContainer>
      </div>
      </ModalContainer>
    </PageContainer>
  );
}